import { PopupType } from '../../components/popup/types';
import { CrossOriginCommunication } from '../../controllers/crossOriginCommunication/CrossOriginCommunicationController';
import { GAME_STATUS } from '../../services/gameCommunication/types';
import type { IGameCommunicationConnectionObserver } from '../../services/gameCommunication/types';
import { SOCKET_CONNECTION_STATUS } from '../../services/webSocket/types';
import type { CoreStoreType } from '../../store/CoreStore';
import { betActions } from '../../store/slices/bets/slice';
import { popupActions } from '../../store/slices/popup/slice';
import { OutgoingMessage } from '../crossOriginCommunication/types';

export class GameCommunicationConnectionObserver implements IGameCommunicationConnectionObserver {
  update(connectedStatus: SOCKET_CONNECTION_STATUS | GAME_STATUS, store: CoreStoreType): void {
    switch (connectedStatus) {
      case SOCKET_CONNECTION_STATUS.RECONNECTING:
        store.dispatch(popupActions.overwritePopup(PopupType.Reconnecting));
        break;
      case SOCKET_CONNECTION_STATUS.RECONNECTED:
        store.dispatch(popupActions.dismissPopup(PopupType.Reconnecting));
        break;
      case SOCKET_CONNECTION_STATUS.CONNECTION_LOST:
        CrossOriginCommunication.dispatch(OutgoingMessage.ErrorMessage, {
          errorCode: '8000',
          errorMessage: 'SERVER_CONNECTIVITY_ERROR',
        });
        store.dispatch(popupActions.overwritePopup(PopupType.ConnectionLost));
        break;
      case GAME_STATUS.NEW_ROUND:
        store.dispatch(betActions.setAcceptedBets([]));
        break;
      default:
        break;
    }
  }
}
